<div class="navigation">
    <input type="checkbox" class="navigation__checkbox" id="navi-toggle" title="hidden checkbox" />
    <label for="navi-toggle" class="navigation__button" id="menuIcon">
        <span class="navigation__icon">
            <i class="bi bi-list"></i>
        </span>
    </label>
    <div class="navigation__background">&nbsp;</div>

    <nav class="navigation__nav">
        <ul class="navigation__list">
            <li class="navigation__item" *ngIf="!user.loggedin">
                <a class="navigation__link" href="/">Home</a>
            </li>
            <li class="navigation__item" *ngIf="!user.loggedin">
                <a class="navigation__link" href="/register">Register</a>
            </li>
            <li class="navigation__item" *ngIf="!user.loggedin">
                <a class="navigation__link" href="/login">Login</a>
            </li>
            <li class="navigation__item" *ngIf="user.loggedin">
                <a class="navigation__link" href="/profile">{{user.username}}</a>
            </li>
            <li class="navigation__item" *ngIf="user.loggedin">
                <a class="navigation__link" href="/home">Home</a>
            </li>
            <li class="navigation__item" *ngIf="user.loggedin">
                <a class="navigation__link" href="/create_role">Create New Role</a>
            </li>
            <li class="navigation__item" *ngIf="user.loggedin">
                <a class="navigation__link" href="/list_roles">See a List of User Roles</a>
            </li>
            <li class="navigation__item">
                <a class="navigation__link" href="/privacy_policy">Privacy Policy</a>
            </li>
            <li class="navigation__item">
              <a class="navigation__link" href="/contact">Contact Us</a>
            </li>
            <li class="navigation__item" *ngIf="user.loggedin">
                <form (ngSubmit)="logoutUser()" #logoutForm="ngForm" method="post">
                    <button type="submit" class="navigation__link-button">Logout</button>
                </form>
            </li>
        </ul>
    </nav>
</div>
